import { useEffect, useState } from "react";
import { message } from 'antd';

import useEstados from './../../../../../hooks/HookEstados';

import expLaboralServices from "./../../../services/alumnos/expLaboralServices";
import rangoSalarialService from "./../../../services/alumnos/rangoSalarialService";
import functions from "./../../../shared/functions";


import dayjs from "dayjs";


const useExpLaboral = (initialData = []) => {

    const [data, setData] = useState(initialData);
    const [editing, setEditing] = useState(null);
    const [newData, setNewData] = useState(false);
    const [loading, setLoading] = useState(false);

    const [catalogRangoSalarial, setCatalogRangoSalarial] = useState([]);
    const { catEstados, getEstado } = useEstados();

    const getRangoSalarial = async () => {
        const services = await rangoSalarialService.getRangoSalarial();
        const rangoFormateado = services.data.map((item) => ({ id: item.id_rango, data: item.rango }));
        setCatalogRangoSalarial(rangoFormateado);
    }

    const fetchData = async () => {
        setLoading(true);
        const response = await expLaboralServices.getExpLaboralMe()
        setLoading(false);
        if (!response.success) return;
        setData(functions.ordenarPorFechaInicial(response.data));
    };

    useEffect(() => {
        getRangoSalarial();
        getEstado();
    }, []);

    useEffect(() => {
        setData(functions.ordenarPorFechaInicial(initialData));
    }, [initialData]);

    const startEdit = (editing) => {
        const clone_record = { ...editing };

        // Separar la fecha de inicio y la fecha de fin, y convertirlas a objetos 'dayjs' si son válidas; 
        // si no son válidas, se asigna 'null' a la fecha de fin.
        const [startDate, endDate] = clone_record.fecha.split('|').map(date => dayjs(date, 'YYYY-MM-DD').isValid() ? dayjs(date, 'YYYY-MM-DD') : null);
        setEditing({ ...clone_record, fecha: [startDate, endDate || null] });

    };

    const cancelEdit = () => {
        setEditing(null);
        setNewData(false);
    };

    const saveRecord = async (record) => {

        const format_date = `${record?.fecha[0]?.format('YYYY-MM-DD')}|${record?.fecha[1]?.isValid() ? record?.fecha[1]?.format('YYYY-MM-DD') : 'Actual'}`;

        if (!record.id_exp && !editing) {
            record.fecha = format_date
            const response = await expLaboralServices.createExpLaboralMe(record);
            if (!response.success) return false;
            message.success('Guardado correctamente');
        } else {
            delete record?.estado;
            delete record?.rango_salarial;

            record.fecha = format_date
            record.id_exp = editing?.id_exp;

            const response = await expLaboralServices.editExpLaboralMe(record);
            if (!response.success) return false;
            message.success('Editado correctamente');
        }
        setEditing(null);
        await fetchData();
        return true;
    };

    const deleteRecord = async (record) => {
        const response = await expLaboralServices.deleteExpLaboralMe(record?.id_exp);
        if (!response.success) return;

        message.success('Experiencia Laboral eliminada correctamente');
        await fetchData();
    };

    return { data, newData, setNewData, editing, startEdit, cancelEdit, saveRecord, deleteRecord, loading, fetchData, catalogRangoSalarial,catEstados};

}

export default useExpLaboral;